import { Tab, Tabs } from "react-bootstrap";
import "../../styles/profile/profileTabs/profileTabs.scss";
import { withLocalize } from "react-localize-redux";
import { useEffect, useState } from "react";
import CredentialsWeb from "../../screens/credentials/CredentialsWeb";
import ProfileTabsLoader from "./ProfileTabsLoader/ProfileTabsLoader";
import BackToTop from "../backToTop/BackToTop";
import CredentialsMobile from "../../screens/credentials/CredentialsMobile";
import styled from "styled-components";
import Color from "../../constants/Color";
import { getMasterConfig } from "wallet-elementkit/dist/constants/master";

const StyledTabs = styled.div`
	${(props) => `
		.nav-link.active {
			color: ${props.primaryColor} !important;
		}
		`};
`;

const masterConfig = getMasterConfig();

function ProfileTabs(props) {
	const [showBackToTop, setShowBackToTop] = useState(false);

	useEffect(() => {
		// Function to handle the scroll event
		const handleScroll = () => {
			// Define the scroll threshold (e.g., 200 pixels)
			const scrollThreshold = 400;

			// Check the current scroll position
			if (window.scrollY > scrollThreshold) {
				// Show the icon if the user has scrolled below the threshold
				setShowBackToTop(true);
			} else {
				// Hide the icon if the user is above the threshold
				setShowBackToTop(false);
			}
		};

		// Attach the scroll event listener when the component mounts
		window.addEventListener("scroll", handleScroll);

		// Remove the scroll event listener when the component unmounts
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	// Fetch Wallet Profile Commented
	// useEffect(() => {
	// 	if (isMounted.current) {
	// 		props.fetchWalletProfile(
	// 			activeSortByValue ? activeSortByValue.value : undefined
	// 		);
	// 	} else {
	// 		isMounted.current = true;
	// 	}
	// }, [activeSortByValue]);

	return props.isLoading && props.activeTab === "credentials" ? (
		<ProfileTabsLoader isMobile={props.isMobile} />
	) : (
		<StyledTabs
			id="profile-tabs"
			className="flex-column"
			primaryColor={masterConfig.primaryColor || Color.mainBlue}
		>
			<Tabs
				defaultActiveKey="credentials"
				id="controlled-tab-example"
				activeKey={props.activeTab}
				style={{
					borderBottom: "none",
					display: props.editModeActive ? "none" : "flex",
				}}
				onSelect={(changedTab) => {
					if (changedTab) props.setActiveTab(changedTab);
				}}
				className="mb-3"
				justify={true}
			>
				<Tab
					eventKey="credentials"
					title={props.translate("credentials").toString()}
					className="profile-tab"
					style={{ border: "none" }}
				>
					{props.isMobile ? (
						<CredentialsMobile
							certificates={props.certificates.filter(
								(cert) => cert.url !== ""
							)}
							badges={props.certificates.filter(
								(badge) => badge.badgeUrl !== ""
							)}
							userFullName={props.userFullName}
							userPhoto={props.userPhoto}
							isLoading={props.isLoading}
							activeLanguage={props.activeLanguage}
							goToCredentials={props.goToCredentials}
							{...props}
						/>
					) : (
						<CredentialsWeb
							certificates={props.certificates.filter(
								(cert) => cert.url !== ""
							)}
							badges={props.certificates.filter(
								(badge) => badge.badgeUrl !== ""
							)}
							userFullName={props.userFullName}
							userPhoto={props.userPhoto}
							isLoading={props.isLoading}
							activeLanguage={props.activeLanguage}
							goToCredentials={props.goToCredentials}
							{...props}
						/>
					)}
				</Tab>
			</Tabs>
			{showBackToTop && (
				<BackToTop
					styles={{
						position: "fixed",
						bottom: "20px",
						right: "20px",
					}}
					backToTopText={props.translate("backToTop").toString()}
					window={window}
				/>
			)}
		</StyledTabs>
	);
}

export default withLocalize(ProfileTabs);
